import React, { useEffect, useState } from "react"
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  Form,
  TabContent,
  TabPane,
  Alert,
} from "reactstrap"
import Flatpickr from "react-flatpickr"
import "flatpickr/dist/themes/material_blue.css"
import Select from "react-select"
import { Link, useLocation, useNavigate } from "react-router-dom"
import classnames from "classnames"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useFormik } from "formik" // added

// Import Images
import avatar5 from "../../../assets/images/logo-sm.png"
import { useDispatch, useSelector } from "react-redux"
import { toast } from "react-toastify"
import { getProductList, updateUser } from "../../../redux/actions/user"
import TagInput from "components/TagInput"
import {
  getUserBillingInfo,
  regenerateInvoice,
} from "../../../redux/actions/pvs"
import {
  GET_USER_BILLING_INFO_RESET,
  REGENERATE_INVOICE_RESET,
} from "../../../redux/types/pvs"
import moment from "moment"

const RegenerateInvoice = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const location = useLocation()

  const { state } = location
  // const invoice_action = state?.type || "update"

  const [invoiceAction, setinvoiceAction] = useState("update")
  const [registrationId, setRegistrationId] = useState("")

  const token = useSelector(state => state.auth.token)
  const billingInfo = useSelector(state => state.pvs.billingInfo)
  const getUserBillingDetailsScreen = useSelector(
    state => state.screens.pvs.getUserBillingDetails
  )
  const regenerateInvoiceScreen = useSelector(
    state => state.screens.pvs.regenerateInvoice
  )

  useEffect(() => {
    dispatch(
      getUserBillingInfo({ enc_bazaar_register_id: registrationId }, token)
    )
  }, [registrationId])

  useEffect(() => {
    if (state && state.type) {
      setinvoiceAction(state.type)
    }
    if (state && state.id) {
      setRegistrationId(state.id)
    }
  }, [state])

  useEffect(() => {
    if (regenerateInvoiceScreen.success) {
      toast.success(regenerateInvoiceScreen.message)
      dispatch({ type: REGENERATE_INVOICE_RESET })
      navigate(-1)
    }
    if (regenerateInvoiceScreen.error) {
      toast.error(regenerateInvoiceScreen.error)
      dispatch({ type: REGENERATE_INVOICE_RESET })
    }
  }, [regenerateInvoiceScreen])

  useEffect(() => {
    if (getUserBillingDetailsScreen.error) {
      toast.error(getUserBillingDetailsScreen.error)
      dispatch({ type: GET_USER_BILLING_INFO_RESET })
    }
  }, [getUserBillingDetailsScreen])

  const stateOptions = [
    {
      options: [
        {
          label: "Andaman and Nicobar Islands",
          value: 4023,
        },
        {
          label: "Andhra Pradesh",
          value: 4017,
        },
        {
          label: "Arunachal Pradesh",
          value: 4024,
        },
        {
          label: "Assam",
          value: 4027,
        },
        {
          label: "Bihar",
          value: 4037,
        },
        {
          label: "Chandigarh",
          value: 4031,
        },
        {
          label: "Chhattisgarh",
          value: 4040,
        },
        {
          label: "Dadra and Nagar Haveli and Daman and Diu",
          value: 4033,
        },
        {
          label: "Delhi",
          value: 4021,
        },
        {
          label: "Goa",
          value: 4009,
        },
        {
          label: "Gujarat",
          value: 4030,
        },
        {
          label: "Haryana",
          value: 4007,
        },
        {
          label: "Himachal Pradesh",
          value: 4020,
        },
        {
          label: "Jammu and Kashmir",
          value: 4029,
        },
        {
          label: "Jharkhand",
          value: 4025,
        },
        {
          label: "Karnataka",
          value: 4026,
        },
        {
          label: "Kerala",
          value: 4028,
        },
        {
          label: "Ladakh",
          value: 4852,
        },
        {
          label: "Lakshadweep",
          value: 4019,
        },
        {
          label: "Madhya Pradesh",
          value: 4039,
        },
        {
          label: "Maharashtra",
          value: 4008,
        },
        {
          label: "Manipur",
          value: 4010,
        },
        {
          label: "Meghalaya",
          value: 4006,
        },
        {
          label: "Mizoram",
          value: 4036,
        },
        {
          label: "Nagaland",
          value: 4018,
        },
        {
          label: "Odisha",
          value: 4013,
        },
        {
          label: "Puducherry",
          value: 4011,
        },
        {
          label: "Punjab",
          value: 4015,
        },
        {
          label: "Rajasthan",
          value: 4014,
        },
        {
          label: "Sikkim",
          value: 4034,
        },
        {
          label: "Tamil Nadu",
          value: 4035,
        },
        {
          label: "Telangana",
          value: 4012,
        },
        {
          label: "Tripura",
          value: 4038,
        },
        {
          label: "Uttar Pradesh",
          value: 4022,
        },
        {
          label: "Uttarakhand",
          value: 4016,
        },
        {
          label: "West Bengal",
          value: 4853,
        },
      ],
    },
  ]

  useEffect(() => {
    if (billingInfo) {
      console.log("billing info..", new Date(billingInfo.invoice_date))

      billingDetails.setValues({
        firstName: billingInfo.first_name || "",
        lastName: billingInfo.last_name || "",
        companyName: billingInfo.company_name || "",
        address: billingInfo.address || "",
        city: billingInfo.city || "",
        state: billingInfo.state
          ? stateOptions[0].options.find(val => val.label === billingInfo.state)
          : null,
        pincode: billingInfo.pincode || "",
        gstNumber: billingInfo.gst_number || "",
        email: billingInfo.email_id || "",
        mobileNo: billingInfo.mobile_no || "",
        invoiceDate: new Date(billingInfo.invoice_date) || new Date(),
      })
    }
  }, [billingInfo])

  document.title =
    invoiceAction === "update" ? "Update Invoice" : "Regenerate Invoice"

  // simple validators
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  const phoneRegex = /^[6-9]\d{9}$/
  // GSTIN (15 chars) regex — 2 digits (state) + 10-char PAN + 1 entity char + 'Z' + checksum
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/i
  // URL / link validator (allows optional http(s), domain (or localhost), optional port and path/query/fragment)
  const linkRegex =
    /^(https?:\/\/)?((([a-zA-Z0-9-]{1,63}\.)+[a-zA-Z]{2,63})|localhost)(:\d{1,5})?(\/[^\s]*)?$/i

  const billingDetails = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      companyName: "",
      address: "",
      city: "",
      state: null,
      pincode: "",
      gstNumber: "",
      invoiceDate: "",
      email: "",
      mobileNo: "",
    },
    validate: values => {
      const errors = {}
      // if (!values.firstName) errors.firstName = "Required"
      // if (!values.lastName) errors.lastName = "Required"
      // if (!values.companyName) errors.companyName = "Required"
      // if (!values.address) errors.address = "Required"
      // if (!values.city) errors.city = "Required"
      // if (!values.state) errors.state = "Required"
      // if (!values.pincode) errors.pincode = "Required"
      // if (!values.email) errors.email = "Required"
      if (values.email && !emailRegex.test(values.email)) {
        errors.email = "Invalid email"
      }
      if (values.mobileNo && !phoneRegex.test(values.mobileNo)) {
        errors.mobileNo =
          "Invalid Mobile Number (should be 10 digits starting with 6-9)"
      }
      if (values.gstNumber && !gstRegex.test(values.gstNumber)) {
        errors.gstNumber = "Invalid GST Number"
      }

      return errors
    },
    onSubmit: values => {
      console.log("values..", values)

      let requestData = {
        invoice_action: invoiceAction,
        enc_bazaar_register_id: registrationId,
        first_name: values.firstName,
        last_name: values.lastName,
        mobile_no: values.mobileNo,
        email_id: values.email,
        gst_number: values.gstNumber,
        invoice_date: moment(values.invoiceDate).format("YYYY-MM-DD"),
        company_name: values.companyName,
        address: values.address,
        city: values.city,
        state: values.state ? values.state.label : "",
        pincode: values.pincode,
      }
      console.log("request body..", requestData)

      dispatch(regenerateInvoice(requestData, token))
    },
  })

  const onOtherProductsChange = list => {
    console.log("list..", list)

    billingDetails.setFieldValue("otherProducts", list)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="d-flex align-items-center justify-content-between my-4">
          <div>
            <h2 className="h4 mb-0 nom-title">
              {invoiceAction === "update"
                ? "Update Invoice"
                : "Cancel & Regenerate Invoice"}
            </h2>
          </div>
        </div>
        <div className="mb-4"></div>
        <Container fluid>
          <Row>
            <Col xl={12}>
              <Form onSubmit={billingDetails.handleSubmit}>
                {/* Billing Details */}
                <Card>
                  <CardBody className="pb-0">
                    <h4 className="font-size-18 mb-2">Billing Details</h4>
                    <div className="border-top mt-3 pb-3"></div>
                    {/* Primary Contact */}
                    <div className="mb-3 row mt-3">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="primary_contact">
                          Primary Contact &nbsp;
                          <span className="text-danger">*</span>
                        </Label>
                      </div>
                      <div className="col-12 col-sm">
                        <div className="row">
                          <div className="col-12 col-sm-6 mb-3">
                            <Input
                              name="firstName"
                              className="form-control"
                              placeholder="First Name"
                              type="text"
                              id="first_name"
                              value={billingDetails.values.firstName}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.firstName && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.firstName}
                              </div>
                            )}
                          </div>
                          <div className="col-12 col-sm-6">
                            <Input
                              name="lastName"
                              className="form-control"
                              placeholder="Last Name"
                              id="last_name"
                              type="text"
                              value={billingDetails.values.lastName}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.lastName && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.lastName}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3 row mt-3">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="primary_contact">
                          Contact Info &nbsp;
                        </Label>
                      </div>
                      <div className="col-12 col-sm-9">
                        <div className="row">
                          <div className="col-12 col-sm-6 mb-3">
                            <Input
                              name="email"
                              className="form-control"
                              type="email"
                              id="emailr"
                              placeholder="Enter the Email ID"
                              value={billingDetails.values.email}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.email && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.email}
                              </div>
                            )}
                          </div>
                          <div className="col-12 col-sm-6">
                            <Input
                              name="mobileNo"
                              className="form-control"
                              type="number"
                              id="Mob_number"
                              placeholder="Enter the Mobile Number"
                              value={billingDetails.values.mobileNo}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.mobileNo && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.mobileNo}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Company Name */}
                    <div className="mb-3 row">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="company_name">
                          Company Name &nbsp;
                        </Label>
                      </div>
                      <div className="col-12 col-sm-9">
                        <Input
                          name="companyName"
                          className="form-control"
                          type="text"
                          id="company_name"
                          value={billingDetails.values.companyName}
                          onChange={billingDetails.handleChange}
                        />
                        {billingDetails.errors.companyName && (
                          <div className="text-danger small mt-1">
                            {billingDetails.errors.companyName}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* GST Number */}
                    <div className="mb-3 row">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="company_name">
                          GST Number
                        </Label>
                      </div>
                      <div className="col-12 col-sm-9">
                        <div className="row">
                          <div className="col-12 col-sm-6 mb-3">
                            <Input
                              name="gstNumber"
                              className="form-control"
                              type="text"
                              id="gst_number"
                              value={billingDetails.values.gstNumber}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.gstNumber && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.gstNumber}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mb-3 row">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="company_name">
                          Invoice Date
                        </Label>
                      </div>
                      <div className="col-12 col-sm-9">
                        <div className="row">
                          <div className="col-12 col-sm-6 mb-3">
                            <Flatpickr
                              className="form-control d-block"
                              placeholder="MM DD, YYYY"
                              value={billingDetails.values.invoiceDate}
                              options={{
                                altInput: true,
                                altFormat: "F j, Y",
                                dateFormat: "Y-m-d",
                              }}
                              onChange={e => {
                                console.log("date..", e[0])
                                billingDetails.setFieldValue(
                                  "invoiceDate",
                                  e[0]
                                )
                              }}
                            />
                            {billingDetails.errors.invoiceDate && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.invoiceDate}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Address textarea */}
                    <div className="mb-3 row">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="address">
                          Address &nbsp;
                        </Label>
                      </div>
                      <div className="col-12 col-sm-9">
                        <textarea
                          name="address"
                          className="form-control"
                          id="address"
                          rows="3"
                          value={billingDetails.values.address}
                          onChange={billingDetails.handleChange}
                        ></textarea>
                        {billingDetails.errors.address && (
                          <div className="text-danger small mt-1">
                            {billingDetails.errors.address}
                          </div>
                        )}
                      </div>
                    </div>

                    {/* City & State */}
                    <div className="mb-3 row mt-3">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="primary_contact">
                          City & State &nbsp;
                        </Label>
                      </div>
                      <div className="col-12 col-sm">
                        <div className="row">
                          <div className="col-12 col-sm-6 mb-3">
                            <Input
                              name="city"
                              className="form-control"
                              type="text"
                              id="city"
                              placeholder="Enter the City Name"
                              value={billingDetails.values.city}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.city && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.city}
                              </div>
                            )}
                          </div>
                          <div className="col-12 col-sm-6">
                            <Select
                              name="state"
                              value={billingDetails.values.state}
                              onChange={val => {
                                billingDetails.setFieldValue("state", val)
                              }}
                              options={stateOptions}
                              classNamePrefix="select2-selection"
                            />
                            {billingDetails.errors.state && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.state}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Pincode */}
                    <div className="mb-3 row">
                      <div className="col-12 col-sm-3">
                        <Label className="form-label" htmlFor="company_name">
                          Pin Code &nbsp;
                        </Label>
                      </div>
                      <div className="col-12 col-sm-9">
                        <div className="row">
                          <div className="col-12 col-sm-6 mb-3">
                            <Input
                              name="pincode"
                              className="form-control"
                              type="number"
                              id="pincode"
                              value={billingDetails.values.pincode}
                              onChange={billingDetails.handleChange}
                            />
                            {billingDetails.errors.pincode && (
                              <div className="text-danger small mt-1">
                                {billingDetails.errors.pincode}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Button */}
                    <div className="d-flex justify-content-center my-4">
                      <Button
                        type="submit"
                        className="btn primary-button mt-2"
                        disabled={regenerateInvoiceScreen.loading}
                        variant={
                          regenerateInvoiceScreen.loading ? "default" : "active"
                        }
                      >
                        {regenerateInvoiceScreen.loading
                          ? "Processing..."
                          : "Submit"}
                      </Button>
                    </div>
                  </CardBody>
                </Card>
              </Form>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default RegenerateInvoice
